import { observer } from 'mobx-react';
import { accommodationRequest } from '../../../../request/AuthRequest';
import { useEffect, useState } from 'react';
import useStore from '../../../../store';
import { Col, Form, Row, Select, Spin, Table, Typography } from 'antd';
import InputComponent from '../../../../component/InputComponent';
import moment from 'moment';
import { displayFormats } from '../../../../config/Global';
const { Title } = Typography;
const MerchantSubscriptionComponent = observer((props) => {
	const { handleChange, onFinish, id, form } = props;
	const [subscriptionLoading, setSubscriptionLoading] = useState(true);

	const columns = [
		{
			title: 'Subscription Name',
			dataIndex: 'subscriptionName',
			key: 'subscriptionName',
		},
		{
			title: 'Date',
			dataIndex: 'createdOn',
			key: 'createdOn',
			render: (text) => moment(text).format(displayFormats.DATE_FORMAT),
		},
		{
			title: 'Active Status',
			dataIndex: 'isActive',
			key: 'isActive',
			render: (isActive) => (isActive === true ? 'Active' : 'Inactive'),
		},
	];

	const {
		ACCOMMODATION: {
			accommodationDetail,
			subscriptionList,
			subscriptionHistory,
			getSubscriptionList,
			ReadSubscriptionHistory,
		},
	} = useStore();

	useEffect(() => {
		ReadSubscriptionHistory(props.merchantId);
	}, []);

	return (
		<>
			<Form
				id={id}
				layout="vertical"
				form={form}
				onFinish={onFinish}
				autoComplete="off"
				onChange={handleChange}
			>
				<Row gutter={24}>
					<Col span={8}>
						<InputComponent
							required
							type="select"
							showSearch={true}
							name="eSubscriptionId"
							label="Select Subscription"
							placeholder="Select Subscription"
							onFocus={() => {
								getSubscriptionList().then(() =>
									setSubscriptionLoading(false)
								);
							}}
							notFoundContent={
								subscriptionLoading ? (
									<Spin size="small" />
								) : (
									'No Data Found'
								)
							}
							options={{
								values: accommodationDetail
									? [
											{
												eRegionId:
													accommodationDetail.eStateId,
												regionName:
													accommodationDetail.stateName,
											},
										]
									: subscriptionList,
								value_key: 'eSubscriptionId',
								text_key: 'subscriptionName',
							}}
							onChange={handleChange}
							rules={accommodationRequest.subscription}
						/>
					</Col>
				</Row>
			</Form>
			<Title level={3} style={{ textAlign: 'center' }}>
				Subscription History
			</Title>
			<Table
				dataSource={subscriptionHistory}
				columns={columns}
				pagination={false}
			/>
		</>
	);
});

export default MerchantSubscriptionComponent;
